//@flow
import { IStepFeedback } from "../userCampaign/types";
import {
  HISTORICAL_REFRESH,
  HISTORICAL_LOAD_REQUESTING,
  HISTORICAL_REFRESH_REQUESTING,
  HISTORICAL_LOAD,
  EVENT_CREATE,
  HISTORICAL_UNSET,
  HISTORICAL_VISIBLE,
  HISTORICAL_SELECT,
  SELECT_FEEDBACK,
} from "./constants";

type eventType = {
  picture: string;
  trackTitle: string;
  trackAchievement: string;
  doneMessage: string;
  userId: string;
  trackId: string;
  friends: [];
};

type historicalType = [];

// utilisé ?
export const createEvent = (payload: eventType) => {
  return {
    type: EVENT_CREATE,
    payload,
  };
};

// utilisé ?
export const unsetHistorical = () => {
  return {
    type: HISTORICAL_UNSET,
  };
};

export const loadHistoricalRequest = (payload: {
  userId: string;
  historicalIndex: number;
}) => {
  return {
    type: HISTORICAL_LOAD_REQUESTING,
    payload,
  };
};

// utilisé ?
export const visibleHistorical = payload => {
  return {
    type: HISTORICAL_VISIBLE,
    payload,
  };
};

// qu'est ce que l'historial type ?
export const loadHistorical = (payload: historicalType) => {
  return {
    type: HISTORICAL_LOAD,
    payload,
  };
};

// même question
export const refreshHistoricalRequest = (payload: historicalType) => {
  return {
    type: HISTORICAL_REFRESH_REQUESTING,
    payload,
  };
};

// même question
export const refreshHistorical = (payload: historicalType) => {
  return {
    type: HISTORICAL_REFRESH,
    payload,
  };
};

// ca pourrait correspondre à IHistoricalData.... mais pas sure
export const selectHistorical = payload => {
  return {
    type: HISTORICAL_SELECT,
    payload,
  };
};

export const selectFeedback = (payload: { feedback: string }) => {
  return {
    type: SELECT_FEEDBACK,
    payload,
  };
};
